import React, { useState, useEffect, useContext } from 'react'

import UserContext from '../context/UserContext'

import { Link, useNavigate } from 'react-router-dom'


function Navbar() {
  const { signOut } = useContext(UserContext)
  const [reportId, setReportId] = useState()
  const navigate = useNavigate()

  const searchHandler = (e) => {
    e.preventDefault()
    const term = e.target.term.value
    navigate(`/search/${term}`)
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand" style={{minWidth: '20'}}><img src="https://media-monitoring-assets.s3.amazonaws.com/fcc-seal-rgb-2020-80x80.png" style={{ width: '60px' }} /></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/home/reports" className="nav-link">Reports</Link>
              </li>
              <li className="nav-item">
                <Link to="/home/daily" className="nav-link">Daily Report</Link>
              </li>
            </ul>
            <form onSubmit={searchHandler} className="d-flex" role="search">
              <input className="form-control  form-control-sm me-2" type="search" name="term" placeholder="Search Articles" aria-label="Search" />
              <button className="btn btn-outline-light me-2" type="submit"><i className="fa-solid fa-magnifying-glass"></i></button>
            </form>
            <button className="btn btn-outline-light" onClick={signOut}>Sign out</button>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar